var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDialogFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#e9e9e9;}.d{fill:silver;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 192,
    height: 192,
    transform: "translate(596 292)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-596 -292)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592.903 288.903)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M164.129,51.363V80.516h29.153Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M161.032,86.71a3.1,3.1,0,0,1-3.1-3.1V49.548H99.1a9.29,9.29,0,0,0-9.29,9.29v6.194H83.613a9.29,9.29,0,0,0-9.29,9.29V185.806a9.29,9.29,0,0,0,9.29,9.29h86.71a9.29,9.29,0,0,0,9.29-9.29v-6.194h6.194a9.29,9.29,0,0,0,9.29-9.29V86.71ZM108.387,65.032h34.065a3.1,3.1,0,0,1,0,6.194H108.387a3.1,3.1,0,0,1,0-6.194Zm0,15.484h34.065a3.1,3.1,0,0,1,0,6.194H108.387a3.1,3.1,0,0,1,0-6.194Zm65.032,105.29a3.1,3.1,0,0,1-3.1,3.1H83.613a3.1,3.1,0,0,1-3.1-3.1V74.323a3.1,3.1,0,0,1,3.1-3.1h6.194v99.1a9.29,9.29,0,0,0,9.29,9.29h74.323ZM105.29,161.032a3.1,3.1,0,0,1,3.1-3.1h37.161a3.1,3.1,0,0,1,0,6.194H108.387A3.1,3.1,0,0,1,105.29,161.032Zm71.226-12.387H108.387a3.1,3.1,0,1,1,0-6.194h68.129a3.1,3.1,0,0,1,0,6.194Zm0-15.484H108.387a3.1,3.1,0,0,1,0-6.194h68.129a3.1,3.1,0,0,1,0,6.194Zm0-15.484H108.387a3.1,3.1,0,1,1,0-6.194h68.129a3.1,3.1,0,0,1,0,6.194Zm0-15.484H108.387a3.1,3.1,0,1,1,0-6.194h68.129a3.1,3.1,0,0,1,0,6.194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.645,3.1H130.065A3.1,3.1,0,0,0,127.876,4L116.4,15.484H30.968a3.1,3.1,0,0,0-3.1,3.1v9.29h-9.29a3.1,3.1,0,0,0-3.1,3.1v9.29H6.194a3.1,3.1,0,0,0-3.1,3.1v58.839a15.5,15.5,0,0,0,15.484,15.484H142.452a15.5,15.5,0,0,0,15.484-15.484V12.387A9.29,9.29,0,0,0,148.645,3.1Zm-120.774,99.1a9.29,9.29,0,1,1-18.581,0V46.452h6.194V99.1a3.1,3.1,0,0,0,6.194,0V34.065h6.194Zm123.871,0a9.29,9.29,0,0,1-9.29,9.29H30.887a15.323,15.323,0,0,0,3.177-9.29V21.677h83.613a3.1,3.1,0,0,0,2.189-.907l11.48-11.48h17.3a3.1,3.1,0,0,1,3.1,3.1Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogFile);
export default __webpack_public_path__ + "static/media/dialog-file.6d1e8f4627c7d3bdb0141c7fd16487a7.svg";
export { ForwardRef as ReactComponent };